import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
	top: string
	left: string
	radius: string
	right?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'packageDetalisPopUp',
  props: {
    top: { default: "30px" },
    left: { default: "30px" },
    radius: { default: "5px" },
    right: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "position-absolute package-info-container text-grey-900 caption text-wrap d-none d-md-flex font-size-12 line-height-14 py-2 d-flex flex-column justify-content-center position-absolute",
    style: _normalizeStyle({
			top: props.top,
			...(props.right ? { right: props.right } : { left: props.left }),
			'border-radius': props.radius,
		})
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})